import { organizationConstants as oc } from 'srcReact/OrganizationPage'
import { alertActions } from 'srcReact/Alert'
import { userService, organizationService, workplaceService, subscriptionService } from 'srcReact/services'
import history from 'srcReact/helpers/history'
import { getCookie, objectMap, setCookie } from 'srcReact/helpers/utils'
import { isEmpty } from 'srcReact/helpers/validator'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { loginActions } from 'srcReact/LoginPage'
import { subscriptionActions } from 'srcReact/SubscriptionPage'

export const organizationActions = {
  canAccess,
  setCurrentOrganization,
  getOrganizationInfo,
  getOrganizationById,
  getByUser,
  getWorkplaces,
  getUsers,
  create,
  deleteOrganization,
  switchOrganization,
  getMemberDirectory,
  getNotificationList,
  markNotificationAsRead,
  getHeaderInfo,
  setNativeCurrentOrganization,
  notificationTemporaryMute,
  notificationTemporaryUnmute
}

function canAccess(service, id) {
  let service_type
  if (service == 'page-create-organization') {
    service_type = 'CAN_ACCESS_CREATE_PAGE'
  } else if (service == 'page-list-organization') {
    service_type = 'CAN_ACCESS_LIST_PAGE'
  } else if (service == 'page-index-organization') {
    service_type = 'CAN_ACCESS_INDEX_PAGE'
  }

  return (dispatch) => {
    dispatch(request(service, service_type))

    userService.isAuthorized(service, '').then(
      (response) => {
        dispatch(success(response, service_type))
        if (service == 'page-index-organization') {
          dispatch(getOrganizationById(id))
          dispatch(getWorkplaces(id, 20))
          dispatch(getUsers(id))
        } else if (service == 'page-list-organization') {
          dispatch(getByUser(20))
        }
      },
      (error) => {
        dispatch(failure(error, service_type))
      }
    )
  }

  function request(service, service_type) {
    return { type: oc[`${service_type}_REQUEST`], service }
  }
  function success(response, service_type) {
    return { type: oc[`${service_type}_SUCCESS`], response }
  }
  function failure(error, service_type) {
    return { type: oc[`${service_type}_FAILURE`], error }
  }
}

function setCurrentOrganization(organization, redirect) {
  return async (dispatch) => {
    dispatch({ type: oc.SET_CURRENT_ORGANIZATION_ID, organization })

    if (redirect === true) {
      window.location = `${location.protocol}//${location.hostname}/0/workplaces`
    }
  }
}

function switchOrganization(organization, redirect) {
  const { resourceKey: orgId } = organization
  return (dispatch) => {
    dispatch(request(orgId))
    organizationService.switchOrganization(orgId).then(
      (response) => {
        dispatch(success(organization))
        localStorage.removeItem('request_to_delete')
        if (redirect === true) {
          window.location = `${location.protocol}//${location.hostname}/0/${appConstantSettings.DEFAULT_HOMEPAGE}`
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.SWITCH_ORGANIZATION_REQUEST, response }
  }
  function success(organization) {
    return { type: oc.SWITCH_ORGANIZATION_SUCCESS, organization }
  }
  function failure(error) {
    return { type: oc.SWITCH_ORGANIZATION_FAILURE, error }
  }
}

function getMemberDirectory(id, workplaceId, searchByMember, orderBy, quantity, pagination) {
  return (dispatch) => {
    const { nextOffset, isPagination } = pagination
    dispatch(request({ id, isPagination }))

    organizationService.getMemberDirectory(id, workplaceId, searchByMember, orderBy, quantity, nextOffset).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.GET_MEMBER_DIRECTORY_REQUEST, response }
  }
  function success(response) {
    return { type: oc.GET_MEMBER_DIRECTORY_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.GET_MEMBER_DIRECTORY_FAILURE, error }
  }
}

function getOrganizationById(id) {
  return (dispatch) => {
    dispatch(request({ id }))

    organizationService.getById(id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.GET_ORGANIZATION_REQUEST, response }
  }
  function success(response) {
    return { type: oc.GET_ORGANIZATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.GET_ORGANIZATION_FAILURE, error }
  }
}

function getOrganizationInfo(id, redirect, loadOrgaList) {
  return (dispatch) => {
    dispatch(request({ id }))

    organizationService.getByIdAndUser(id).then(
      (response) => {
        const list = response.list
          ? objectMap(
              response.list,
              (orga) => {
                return {
                  ...orga.info,
                  ...orga.organizations_basicsettings,
                  my_access: orga.organizations_my_access,
                  my_rights: orga.workplaces_my_rights
                }
              },
              true
            )
          : []
        if (list.length > 0) {
          dispatch(success(list[0]))
          if (redirect === true) {
            window.location = `${location.protocol}//${location.hostname}/0/workplaces`
          }
          if (loadOrgaList === true) {
            dispatch(getByUser(appConstantSettings.ORG_LIST_QTY))
          }
        } else {
          dispatch(failure('Error: get access!'))
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.GET_ORGANIZATION_REQUEST, response }
  }
  function success(organization) {
    return { type: oc.GET_ORGANIZATION_SUCCESS, organization }
  }
  function successList(response) {
    return { type: oc.LIST_ORGA_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.GET_ORGANIZATION_FAILURE, error }
  }
}

function getByUser(qty, switchOrg = false) {
  return async (dispatch) => {
    dispatch(request({ qty }))
    if (qty) {
      let orgId = 0
      let origin = ''
      if (localStorage.getItem('ssoOrgId') !== null) {
        orgId = parseInt(localStorage.getItem('ssoOrgId'))
        origin = 'sso'
      } else if (localStorage.getItem('mixrOrgId') !== null) {
        orgId = parseInt(localStorage.getItem('mixrOrgId'))
      }
      organizationService.getByUser(qty, 0, orgId, origin).then(
        async (response) => {
          if (!isEmpty(response.list)) {
            // (getCookie('current_organization_id') == null || localStorage.getItem('current_organization') == null)
            const list = objectMap(
              response.list,
              (orga) => {
                return {
                  ...orga.info,
                  ...orga.organizations_basicsettings,
                  my_access: orga.organizations_my_access,
                  my_rights: orga.workplaces_my_rights
                }
              },
              true
            )
            if (switchOrg) {
              await dispatch(switchOrganization(list[0], true))
            } else {
              await dispatch(setCurrentOrganization(list[0]))
            }
          } else {
            if (localStorage.getItem('request_to_delete')) {
              await dispatch(loginActions.userLogout())
            } else {
              await dispatch(setCurrentOrganization(null))
              localStorage.removeItem('current_organization')
              setCookie('current_organization_id', false, -1)
            }
          }

          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    }
  }

  function request(response) {
    return { type: oc.LIST_ORGA_REQUEST, response }
  }
  function success(response) {
    return { type: oc.LIST_ORGA_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.LIST_ORGA_FAILURE, error }
  }
}

function getWorkplaces(organizationId, callbackRedirect) {
  return (dispatch) => {
    dispatch(request({ organizationId }))

    workplaceService.getWorkplaces(organizationId).then(
      (response) => {
        dispatch(success(response))
        if (
          typeof callbackRedirect === 'function' &&
          (response.length === 0 || response?.workplace_list?.length === 0)
        ) {
          callbackRedirect()
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.LIST_WORKPLACE_REQUEST, response }
  }
  function success(response) {
    return { type: oc.LIST_WORKPLACE_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.LIST_WORKPLACE_FAILURE, error }
  }
}

function getUsers(id) {
  return (dispatch) => {
    dispatch(request({ id }))

    userService.getByOrganizationId(id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.GET_USERS_REQUEST, response }
  }
  function success(response) {
    return { type: oc.GET_USERS_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.GET_USERS_FAILURE, error }
  }
}

function create(name, pictureId, color) {
  return async (dispatch) => {
    dispatch(request({ name, pictureId, color }))
    organizationService.create(name, pictureId, color).then(
      async (response) => {
        try {
          await dispatch(getHeaderInfo(response.id, 'subscription,sidebar', 'v2_migration'))
          await dispatch(switchOrganization(response, false))
          await dispatch(subscriptionActions.redirectToSubscriptionCheckout(response.id, 'plan-free'))

          dispatch(success(response))
        } catch (error) {}
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error[0]))
      }
    )
  }

  function request(response) {
    return { type: oc.CREATE_ORGA_REQUEST, response }
  }
  function success(response) {
    return { type: oc.CREATE_ORGA_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.CREATE_ORGA_FAILURE, error }
  }
}

function deleteOrganization(id, callbackSuccess) {
  return (dispatch) => {
    dispatch(request(id))

    organizationService.remove(id).then(
      (response) => {
        dispatch(success(id))
        if (typeof callbackSuccess === 'function') {
          callbackSuccess()
        }
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error.message.toString()))
      }
    )
  }

  function request(response) {
    return { type: oc.DELETE_ORGA_REQUEST, response }
  }
  function success(response) {
    return { type: oc.DELETE_ORGA_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.DELETE_ORGA_FAILURE, error }
  }
}
function getNotificationList(organizationId, isRead, pagination, quantity = appConstantSettings.PAGINATION_QUANTITY) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination))

    organizationService.getNotificationList(organizationId, isRead, nextOffset, quantity).then(
      (response) => {
        dispatch(success(response, isPagination))
      },
      (error) => {
        // dispatch(alertActions.error(error))
        dispatch(failure(error))
      }
    )
  }

  function request(isPagination) {
    return { type: oc.GET_NOTIFICATIONS_REQUEST, isPagination }
  }
  function success(response, isPagination) {
    return { type: oc.GET_NOTIFICATIONS_SUCCESS, response, isPagination }
  }
  function failure(error) {
    return { type: oc.GET_NOTIFICATIONS_FAILURE, error }
  }
}

function markNotificationAsRead(organizationId, notificationId) {
  return (dispatch) => {
    dispatch(request(organizationId, notificationId))

    organizationService.markNotificationAsRead(organizationId, notificationId).then(
      (response) => {
        dispatch(success(response, organizationId, notificationId))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(organizationId, notificationId) {
    return { type: oc.MARK_NOTIFICATIONS_READ_REQUEST, organizationId, notificationId }
  }
  function success(response, organizationId, notificationId) {
    return { type: oc.MARK_NOTIFICATIONS_READ_SUCCESS, response, organizationId, notificationId }
  }
  function failure(error) {
    return { type: oc.MARK_NOTIFICATIONS_READ_FAILURE, error }
  }
}

function getHeaderInfo(organizationId, scope = '', popup = '', fromChargebee = 0, newsFeedId = -1) {
  return (dispatch) => {
    dispatch(request(organizationId, scope, popup, fromChargebee))

    organizationService.getHeaderInfo(organizationId, scope, popup, fromChargebee, newsFeedId).then(
      (response) => {
        dispatch(success(response, organizationId, scope, popup, fromChargebee))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(organizationId, scope, popup, fromChargebee) {
    return { type: oc.GET_HEADER_REQUEST, organizationId, scope, popup, fromChargebee }
  }
  function success(response, organizationId, scope, popup, fromChargebee) {
    return { type: oc.GET_HEADER_SUCCESS, response, organizationId, scope, popup, fromChargebee }
  }
  function failure(error) {
    return { type: oc.GET_HEADER_FAILURE, error }
  }
}

function setNativeCurrentOrganization(currentOrganization) {
  return {
    type: oc.SET_NATIVE_CURRENT_ORGANIZATION,
    currentOrganization
  }
}

function notificationTemporaryMute(minutes) {
  return (dispatch) => {
    dispatch(request(minutes))

    organizationService.notificationTemporaryMute(minutes).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.NOTIFICATION_TEMPORARY_MUTE_REQUEST, response }
  }
  function success(response) {
    return { type: oc.NOTIFICATION_TEMPORARY_MUTE_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.NOTIFICATION_TEMPORARY_MUTE_FAILURE, error }
  }
}

function notificationTemporaryUnmute() {
  return (dispatch) => {
    dispatch(request())

    organizationService.notificationTemporaryUnmute().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: oc.NOTIFICATION_TEMPORARY_UNMUTE_REQUEST, response }
  }
  function success(response) {
    return { type: oc.NOTIFICATION_TEMPORARY_UNMUTE_SUCCESS, response }
  }
  function failure(error) {
    return { type: oc.NOTIFICATION_TEMPORARY_UNMUTE_FAILURE, error }
  }
}
